<template>
    <div class="main-content">
        <section class="text-center vertical-center" v-cloak>
            <div class="save-document-form" style="margin: auto;" v-if="!freePlan && !joined">
                <h2>You’re joining {{ team.name }}</h2>
                <button class="btn btn-primary mr-0 mt-3 mx-auto" @click="checkTeamJoinStatus()">Join</button>
            </div>
            <div class="save-document-form" style="margin: auto;" v-else>
                <h2>Successfully joined! To access the team, you need to upgrade your account to a paid plan.</h2>
            </div>
        </section>
    </div>
</template>

<script>
import ApiService from "../../api/api.service";

export default {
    name: "TeamMemberJoin",
    data() {
        return {
            freePlan: false,
            joined: false,
            team: null,
        };
    },
    mounted() {
        // check if user is already joined
        this.checkTeamJoinStatus(true);
    },

    methods: {
        checkTeamJoinStatus(checkOnly = false) {
            ApiService.setHeader();
            ApiService.post('/api/teams/member-status', { uuid: this.$route.params.uuid, check_only: checkOnly })
                .then(({data}) => {
                    this.joined = data.joined;
                    this.team = data.team;
                    if(data.joined) {
                        if(! data.free_plan) {
                            this.$router.push({ name: 'Switch Team' })
                        } else {
                            this.freePlan = true
                        }
                    }


                })
                .catch();
        }
    }
}
</script>

<style scoped>

</style>
